// @ts-check
import { computed, ref } from 'vue';

import { createTemplates } from '@/store/modules/bulkSend/factories/templates';
import { createEnvelope } from '@/store/modules/envelopes/factories/envelope';

/** @typedef {import('@/store/modules/envelopes/models/Envelope').TEnvelope} TEnvelope */

// @TODO dummy data, replace with query
const envelope = ref(createEnvelope({ fingerprint: 'fingerprint' }));
const documents = ref(createTemplates(2));

/**
 * Get "draft" envelope
 *
 * @param {string} fingerprint
 */
export function useEnvelope(fingerprint) {
  // @TODO dummy data, replace with query
  const isSent = computed(() => envelope.value.sent_at > 0);
  const stepsProgress = ref();

  /** @type {import('vue').Ref<TEnvelope>} */
  const blankEnvelope = ref({});

  return {
    envelope: fingerprint ? envelope : blankEnvelope,
    documents,
    isSent,
    stepsProgress,
  };
}
